iScreenWizard.factory('Kandidaat', function ($q, Ajax) {

    var data = {};

    data.all = function(params) {
        if (typeof params === 'undefined') {
            params = {};
        }
        return $q(function (resolve, reject) {
            Ajax.get('kandidaat', params).then(function (response) {
                var kandidaten = response.data;
                resolve(kandidaten);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('kandidaat/'+id).then(function (response) {
                var kandidaat = response.data;
                resolve(kandidaat);
            }, reject);
        });
    };

    data.update = function(kandidaat) {
        params = {
            _method: 'put',
            achternaam: kandidaat.achternaam,
            voornaam: kandidaat.voornaam,
            email: kandidaat.email
        };

        return $q(function (resolve, reject) {
            Ajax.post('kandidaat/'+kandidaat.id, params).then(function (response) {
                resolve(response);
            }, reject);
        });
    };

    return data;
});